import Link from 'next/link';

interface Props {
  headingClassName?: string;
  headingText?: string;
  paragraphClassName?: string;
  addressClassName?: string;
}

export const EnterByPostBlurb = (props: Props) => {
  return (
    <>
      <h3 className={props.headingClassName || 'visuallyHidden'}>
        {props.headingText || 'By Post'}
      </h3>
      <p className={props.paragraphClassName}>
        DAYMADE offers an alternative means of entering in to prize draws. The
        process for using this alternative means of entry is described in detail
        below.
      </p>
      <p className={props.paragraphClassName}>
        Just like the standard way of entering the prize draw, this alternative
        method requires you to accept all our{' '}
        <Link
          href="/terms-and-conditions"
          className="linkReset textDecorationUnderline"
        >
          Terms and Conditions
        </Link>{' '}
        as well as require you to be older than 18 years old.
      </p>
      <p className={props.paragraphClassName}>
        On a blank sheet of paper, write your name, address, date of birth,
        email address and which prize draw you want to enter (e.g. if you want
        to enter the Pound Raffle, please specify 'Pound Raffle' OR if you want
        to enter a Weekly Draw, please specify 'Weekly Draw Tuesday' or 'Weekly
        Draw Friday').
      </p>
      <p className={props.paragraphClassName}>
        If you don't specify which Weekly Draw you would like to be entered for,
        then you will be entered into the Friday draw. If you want to boost your
        Weekly Draw entry, then write "boost" on your postal entry.
      </p>
      <p className={props.paragraphClassName}>
        This all needs to be written down in very clear writing otherwise the
        entry will be deemed invalid. Send the sheet of paper in an envelope to
        the following address via either first or second class post:
      </p>
      <p className={props.addressClassName}>
        DAYMADE LTD
        <br />
        66 Paul Street
        <br />
        London
        <br />
        EC2A 4NA
        <br />
      </p>
      <p className={props.paragraphClassName}>
        A maximum of one entry can be made per postcard or envelope received.
        The entry can only be applied to one prize draw. As per our{' '}
        <Link
          href="/terms-and-conditions"
          className="linkReset textDecorationUnderline"
        >
          Terms & Conditions
        </Link>
        , you may only enter up to four postal/paid entries per Weekly Draw.
      </p>
      <p className={props.paragraphClassName}>
        Any additional postal entries sent after hitting this limit will be
        discarded. Please note that, in the case where you don't specify a prize
        draw OR if you include more than one prize draw, you will (only) be
        entered into our Weekly Draw on Friday.
      </p>
      <p className={props.paragraphClassName}>
        Entries received by post will be processed within ten working days. Once
        a postal entry has been processed it will be emailed to you. The email
        will include your numbers. If you have entered a Weekly Draw, your
        numbers will be chosen via a random number generator (you cannot pick
        your own numbers). Once a postal entry has been processed it will be
        entered in to the next available draw for which the cut-off time has not
        yet passed.
      </p>
      <p className={props.paragraphClassName}>
        Weekly postal entrants will be considered subscribers and will benefit
        from all the same perks as paying subscribers. Postal entries are
        treated as exactly the same as paid entries for the purposes of
        determining a winner, and have an equal chance of winning as any paid
        entries. If a postal entry wins a prize there will be no further
        purchase or payment necessary to be notified of the win or to receive
        the prize. If the above steps are not followed as described then a
        postal entry will be invalid. You will not be notified if your entry is
        invalid.
      </p>
      <p className={props.paragraphClassName}>
        Due to the rapid nature of the Pound Raffle and Token Town raffles (with
        prizes changing very frequently), if you send a postal entry and that
        turns out to be the winning entry, you get given the option to choose
        from all historical prizes of that specific raffle.
      </p>
    </>
  );
};
